import { IOrderItem, IDiscountItemMap } from '../../model/order.store'
import { includes, forEach } from 'lodash'
import { isBefore, isAfter } from 'date-fns'

/**
 * Chương trình sale giảm giá 30k menu bánh Tiramisu sinh nhật Savor Cake
 * - Áp dụng từ 27/3/2026 đến 10/5/2026
 */

const TIRAMISU_BIRTHDAY_SKUS = [
  'V1850',
  'V1865',
  'V1880',
  'V10221',
  'V10238',
  'V9106',
  'V9108',
  'V9110',
  'V9065',
  'V9067',
  'V9069',
  'V10308',
  'V10309',
  'V9071',
  'V9073',
  'V9075',
  'V10310',
  'V10311'
]

const DISCOUNT_AMOUNT = 30000

const DEADLINE_START = new Date('2026-03-27T00:00:00+07:00')
const DEADLINE_END = new Date('2026-05-10T23:59:59+07:00')

interface IProcessTiramisuBirthdayDiscountParams {
  items: IOrderItem[]
  resultMap: IDiscountItemMap
  deadline: Date
}

export function processTiramisuBirthdayCakeDiscount({
  items,
  resultMap,
  deadline
}: IProcessTiramisuBirthdayDiscountParams): void {
  if (isBefore(deadline, DEADLINE_START) || isAfter(deadline, DEADLINE_END)) {
    return
  }

  forEach(items, item => {
    if (!includes(TIRAMISU_BIRTHDAY_SKUS, item.sku)) {
      return
    }
    const discount = Math.max(item.quantity * DISCOUNT_AMOUNT, 0)
    resultMap[item.id].discount = discount
    resultMap[item.id].saleProgram = 'Giảm giá bánh Tiramisu sinh nhật'
  })
}
